<ac-nav-header [appName]="'Browse Models' | dcr: 'MB_FUND_PERFORMANCE_TITLE'" gridClass=""></ac-nav-header>

<div class="grid">
	<ng-container *ngIf="componentRequests.length; else fundPerformanceLoadingSkeleton">
		<ng-template [componentId]="componentRequests" let-res [loading]="fundPerformanceLoadingSkeleton">
			<h2 class="title-main margin-bottom-20">
				{{ modelExternalName ? modelExternalName : familyName }}
			</h2>
			<perf-fund-performance [data]="res['me.performance.fund']" [showAssetClasses]="false" [shouldAddLineSeparator]="false" [showPagination]="true"></perf-fund-performance>
			<perf-fees [data]="res['me.performance.fees']" [showAssetClasses]="false" [showPagination]="true"></perf-fees>
			<mb-family-footer [familyId]="familyId" [showFundPerformanceLink]="false"></mb-family-footer>
		</ng-template>
	</ng-container>

	<ng-template #fundPerformanceLoadingSkeleton>
		<perf-fund-performance-skeleton></perf-fund-performance-skeleton>
		<perf-fees-skeleton></perf-fees-skeleton>
	</ng-template>
</div>
